import { render } from "./Register.vue?vue&type=template&id=56e49e62&scoped=true"
import script from "./Register.vue?vue&type=script&lang=ts"
export * from "./Register.vue?vue&type=script&lang=ts"

import "./Register.vue?vue&type=style&index=0&id=56e49e62&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-56e49e62"

export default script